/**
 * TODO: remove the 'secondary' variant as that is what ProductTooltip is for
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import cn from 'classnames';
import { isEmpty, values } from 'lodash';
import _, { noop } from 'lodash/fp';
import get from 'lodash/get';
import T from 'prop-types';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AMPLITUDE_EVENTS } from '../../../constants/analytics';
import { ADD_ONS, ADD_ONS_PROP_NAME, PRODUCT_PROS_CONS, PRODUCT_TYPE } from '../../../constants/product';
import { amplitudeTrack } from '../../../utilities';
import { selectionChildren } from '../../../utilities/map';
import Tooltip from '../../Tooltip';
import Icon from '../../icon/Icon';
import AddOnIcon from '../../icon/common/AddOnIcon';
import { convertGeometries, getAddOnConfig } from '../drawingManager/utilities';
import { MapViewContext } from '../mapViewContext';
import ProductCard from '../productCard/ProductCard';
var ORDERED_DATA = AMPLITUDE_EVENTS.ORDERED_DATA;
var IconWrapper = function(_param) {
    var _param_isAddOn = _param.isAddOn, isAddOn = _param_isAddOn === void 0 ? false : _param_isAddOn, rest = _object_without_properties(_param, [
        "isAddOn"
    ]);
    if (!isAddOn) {
        return /*#__PURE__*/ React.createElement(Icon, rest);
    }
    return /*#__PURE__*/ React.createElement(AddOnIcon, rest);
};
var ProductControlsButton = function(param) {
    var productType = param.productType, _param_withExplanation = param.withExplanation, withExplanation = _param_withExplanation === void 0 ? false : _param_withExplanation, _param_variant = param.variant, variant = _param_variant === void 0 ? 'default' : _param_variant, _param_placement = param.placement, placement = _param_placement === void 0 ? 'right-start' : _param_placement, _param_asPopover = param.asPopover, asPopover = _param_asPopover === void 0 ? false : _param_asPopover, _param_disableSetHoveredProductType = param.disableSetHoveredProductType, disableSetHoveredProductType = _param_disableSetHoveredProductType === void 0 ? false : _param_disableSetHoveredProductType, deliveryMethod = param.deliveryMethod, _param_title = param.title, title = _param_title === void 0 ? '' : _param_title, _param_description = param.description, description = _param_description === void 0 ? '' : _param_description;
    var _state_activeSelection;
    var pros = get(PRODUCT_PROS_CONS, [
        productType,
        'pros'
    ]);
    var cons = get(PRODUCT_PROS_CONS, [
        productType,
        'cons'
    ]);
    var _useContext = useContext(MapViewContext), state = _useContext.state, actions = _useContext.actions;
    var isAddOn = deliveryMethod === ADD_ONS_PROP_NAME;
    var isActiveSelectionAnAddOn = !!state.activeSelectionDataType;
    // Get available product data associated with the current ROI
    var availableProductData = useMemo(function() {
        return _.find([
            'category_name',
            productType
        ], state.coverageInRegionSelection);
    }, [
        state.coverageInRegionSelection,
        productType
    ]);
    var availableProductDataDefault = useMemo(function() {
        return _.find([
            'category_name',
            productType
        ], state.coverageInDefaultRegion);
    }, [
        state.coverageInDefaultRegion,
        productType
    ]);
    var isProductDeactivated = useMemo(function() {
        var _ref = getAddOnConfig(productType) || {}, productControlDataType = _ref.DATA_TYPE;
        if (isAddOn) {
            // if Add-on determine if belongs to exterior or interior
            if (state.activeSelectionDataType) {
                return productControlDataType !== state.activeSelectionDataType;
            }
            // if active selection is interior disable exterior add-on icons
            // or vice versa
            if (state.activeSelection && [
                PRODUCT_TYPE.EXTERIOR,
                PRODUCT_TYPE.INTERIOR
            ].includes(state.activeSelection.category_name)) {
                return state.activeSelection.category_name !== productControlDataType;
            }
        }
        return !state.productAvailability[productType];
    }, [
        state.productAvailability,
        state.activeSelection,
        productType
    ]);
    var isViableSelection = useMemo(function() {
        return !isProductDeactivated && (!state.activeSelection || state.activeSelection.category_name !== productType);
    }, [
        isProductDeactivated,
        state.activeSelection,
        productType
    ]);
    var isActiveSelectionThisProduct = ((_state_activeSelection = state.activeSelection) === null || _state_activeSelection === void 0 ? void 0 : _state_activeSelection.category_name) === productType;
    var getActionDependingOnProduct = useMemo(function() {
        if (ORDERED_DATA.STREETSCAPE_AERIAL.toLowerCase().replace(/ +/g, '').split(',').includes(productType)) {
            return ORDERED_DATA.STREETSCAPE_AERIAL;
        } else {
            return ORDERED_DATA.EXTERIOR_INTERIOR_DRONE;
        }
    }, [
        productType
    ]);
    var getAddOnSetting = function(productType) {
        var selectedAddOnConfig = getAddOnConfig(productType);
        if (!selectedAddOnConfig) {
            return {
                baseProduct: {},
                addOn: {}
            };
        }
        // get selected add-on base Data type e.g exterior or interior from coverage products
        var baseProduct = state.coverage.find(function(param) {
            var category_name = param.category_name;
            return category_name === selectedAddOnConfig.DATA_TYPE;
        });
        // get selected add on product_id, category_name etc. from coverage products
        var addOn = state.coverage.find(function(param) {
            var category_name = param.category_name;
            return category_name === productType;
        });
        return {
            baseProduct: baseProduct,
            addOn: addOn
        };
    };
    var createAddOnWithSelection = function(baseProduct, addOn) {
        var region = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : state.defaultRegion;
        return actions.addSelectionWithAddOn(_object_spread_props(_object_spread({}, availableProductDataDefault), {
            product_id: baseProduct.product_id,
            display_name: baseProduct.display_name,
            category_name: baseProduct.category_name
        }), region, addOn, true);
    };
    var changeProductTypeContainingAddOns = function(baseProduct, addOn) {
        return actions.changeSelectionProductType(state.activeSelection.id, _object_spread_props(_object_spread({}, availableProductData), {
            product_id: baseProduct.product_id,
            display_name: baseProduct.display_name,
            category_name: baseProduct.category_name
        }), {
            product_id: addOn.product_id,
            display_name: addOn.display_name,
            category_name: addOn.category_name
        });
    };
    var handleAddSelection = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _getAddOnSetting, baseProduct, addOn, newSelection, handleDoneChangeType, selectionHasAddOn, activeSelectionChildren, updatedSelection, newRegion;
            return _ts_generator(this, function(_state) {
                amplitudeTrack(ORDERED_DATA.EVENT, {
                    action: getActionDependingOnProduct
                });
                _getAddOnSetting = getAddOnSetting(productType), baseProduct = _getAddOnSetting.baseProduct, addOn = _getAddOnSetting.addOn;
                if (!isViableSelection) {
                    console.warn("product ".concat(productType, " not viable for selection"));
                    return [
                        2
                    ];
                }
                handleDoneChangeType = function(newSelection) {
                    actions.setActiveSelectionId(newSelection === null || newSelection === void 0 ? void 0 : newSelection.id);
                    actions.setHoveredData(null);
                    if (productType === PRODUCT_TYPE.UNKNOWN) {
                        actions.clearProductSelected();
                    }
                };
                if (_.isEmpty(state.debouncedRegionSelection)) {
                    console.assert(!!availableProductDataDefault, 'no available product data found in default region');
                    if (!state.defaultRegion) {
                        console.warn('no default region found');
                        return [
                            2
                        ];
                    }
                    if (!isEmpty(addOn) && !isEmpty(baseProduct)) {
                        createAddOnWithSelection(baseProduct, addOn);
                        return [
                            2
                        ]; // setSelections and etc. handled in actions.addSelectionWithAddOn
                    } else {
                        newSelection = actions.addSelection(availableProductDataDefault, state.defaultRegion, true);
                    }
                } else {
                    console.assert(!!availableProductData, 'no available product data found in region selection');
                    if (state.activeSelection) {
                        if (isAddOn && !isActiveSelectionAnAddOn) {
                            selectionHasAddOn = !!values(ADD_ONS).find(function(param) {
                                var DATA_TYPE = param.DATA_TYPE;
                                return DATA_TYPE === state.activeSelection.category_name;
                            });
                            if (selectionHasAddOn) {
                                actions.createAddOnSelection(productType, state.activeSelection);
                                return [
                                    2
                                ];
                            } else {
                                // Triggered when any of add-ons tool is clicked and changing Draft/Tripods(interior/exterior)
                                newSelection = changeProductTypeContainingAddOns(baseProduct, addOn);
                            }
                        } else {
                            activeSelectionChildren = selectionChildren(state.selections, state.activeSelection.id);
                            updatedSelection = function() {
                                var selectionId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                                return actions.changeSelectionProductType(state.activeSelection.id, availableProductData, {}, selectionId);
                            };
                            if (activeSelectionChildren.length > 0) {
                                actions.showChangeProductTypeConfirmation(productType, activeSelectionChildren, function() {
                                    // callback
                                    var newSelection = updatedSelection();
                                    handleDoneChangeType(newSelection);
                                }, false, productType === PRODUCT_TYPE.UNKNOWN);
                                return [
                                    2
                                ];
                            }
                            newSelection = updatedSelection(!isAddOn && !!state.activeSelection.parent_selection_id ? state.activeSelection.id : null);
                        }
                    } else {
                        newRegion = _.values(convertGeometries(state.debouncedRegionSelection, false))[0].region;
                        if (!isEmpty(addOn) && !isEmpty(baseProduct)) {
                            createAddOnWithSelection(baseProduct, addOn, newRegion);
                            return [
                                2
                            ];
                        } else {
                            newSelection = actions.addSelection(availableProductData, newRegion, true);
                        }
                    }
                }
                console.assert(newSelection);
                handleDoneChangeType(newSelection);
                return [
                    2
                ];
            });
        });
        return function handleAddSelection() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderIcon = function() {
        if (!isViableSelection && isAddOn && !isActiveSelectionThisProduct) {
            return "".concat(productType, "_disabled");
        }
        return variant === 'secondary' ? 'question' : isAddOn && isActiveSelectionThisProduct ? "".concat(productType, "_white") : productType;
    };
    var _useState = _sliced_to_array(useState(false), 2), open = _useState[0], setOpen = _useState[1];
    useEffect(function() {
        if (open) {
            actions.hoverProduct(productType);
        } else {
            actions.unhoverProduct(productType);
        }
    // exhaustive-deps requires `actions` be a dependency when `actions.setHoveredProductType` is the only actual dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        actions.hoverProduct,
        actions.unhoverProduct
    ]);
    return /*#__PURE__*/ React.createElement(Tooltip.Provider, {
        open: open,
        setOpen: setOpen,
        placement: "right-start",
        keepOpenOnHover: true
    }, /*#__PURE__*/ React.createElement(Tooltip.Trigger, {
        onClick: function() {
            return setOpen(function(v) {
                return !v;
            });
        }
    }, /*#__PURE__*/ React.createElement("button", _object_spread({
        type: "button",
        className: cn(productType, {
            ProductBadge: variant !== 'secondary',
            'btn-icon': variant === 'secondary',
            tertiary: variant === 'tertiary',
            focus: isActiveSelectionThisProduct,
            disabled: !isViableSelection,
            deactivated: isProductDeactivated
        })
    }, variant === 'secondary' ? noop : {
        onClick: handleAddSelection
    }), /*#__PURE__*/ React.createElement(IconWrapper, {
        isAddOn: isAddOn,
        className: cn({
            enabled: true
        }),
        icon: renderIcon()
    }))), /*#__PURE__*/ React.createElement(Tooltip.Content, null, /*#__PURE__*/ React.createElement(ProductCard, {
        productType: productType,
        pros: pros,
        cons: cons,
        isDisabled: !isViableSelection,
        handleClick: handleAddSelection,
        variant: variant,
        withExplanation: withExplanation,
        title: title,
        description: description
    })));
};
ProductControlsButton.propTypes = {
    productType: T.string.isRequired,
    scanCategories: T.array,
    withExplanation: T.bool,
    variant: T.oneOf([
        'default',
        'secondary',
        'tertiary'
    ]),
    placement: T.string,
    asPopover: T.bool,
    disableSetHoveredProductType: T.bool,
    title: T.string,
    description: T.string
};
export default ProductControlsButton;
